export const EMAIL = 'Email and Zip Code';
export const MEMBERSHIP_ID = 'Membership ID';
export const ELIGIBILITY_ID = 'Eligibility ID';
export const PREVIOUS_CLIENT = 'Previous Client';
export const CASE_NUMBER = 'Case Number';

export const MEMBER = 'member';
export const SPOUSE = 'spouse';
export const DEPENDENT = 'dependent';
export const SPECIAL_NEEDS_DEPENDENT = 'special needs dependent';

export const COVERAGE_CATEGORIES = [
  [MEMBER, 'Member'],
  [DEPENDENT, 'Dependent'],
  [SPOUSE, 'Spouse'],
  ['parent', 'Parent'],
];

export const COVERAGE_CATEGORIES_PLUS_GRANDPARENT = [
  ...COVERAGE_CATEGORIES,
  ['grandparent', 'Grandparent'],
];

export const VERIFICATION_METHOD_LABEL = "Choose how to verify the client's coverage";
export const VERIFICATION_DATA_LABEL = 'Verify membership';
export const CLIENTS_LABEL = 'Select clients';
export const SERVICES_LABEL = 'Select legal services';
export const ENHANCEMENT_PLAN_LABEL = 'Select Enhancement Plan to view coverage for';
export const CREATE_LABEL = 'Add Member Contact Details';
export const COVERAGE_LOOKUP_LABEL = 'Coverage Lookup';

export const COVERAGE_LOOKUP_ERROR_MESSAGE =
  "Couldn't find coverage for this member at this time! Please get in touch with your panel rep if you think this is an error.";

export const NEW_MEMBER = 'New Member';
export const PREVIOUS_MEMBER = 'Previous Member';

// related services to appear if one of them is chosen in the service selector for attorney check eligibility:
// POA, Trust, Will, and Advance Healthcare Directive
export const ESTATE_PLANNING_CASE_TYPES = [200, 220, 230, 260];
